import { IMemberEventBooking } from '@shared/shared/interfaces/member-event.interfaces';
import * as ArrayLib from '@shared/utils/array.lib';
import * as ObjectLib from '@shared/utils/object.lib';
import * as UrlLib from '@shared/utils/url.lib';
import * as fromActions from '../actions/member-event-booking.actions';

export const initialState: IMemberEventBooking = {
  author: null,
  booked_date: null,
  error: null,
  event_date: null,
  event_date_url: null,
  id: null,
  is_complete: false,
  member_profile: null,
  tickets: [],
  url: null,
};

function transformMemberEventBooking(state: IMemberEventBooking, payload: IMemberEventBooking) {
  const data: Partial<IMemberEventBooking> = ObjectLib.extractAllExceptByKeys(payload, ['tickets']);
  const id = Object.prototype.hasOwnProperty.call(data, 'url') ? { id: UrlLib.extractId(data?.url) } : {};

  const tickets = state.tickets.map((ticket) => {
    let payloadDataTicket = ArrayLib.findByKeyValue(payload.tickets, 'price_type', ticket.price_type);

    payloadDataTicket = ObjectLib.extractAllExceptByKeys(payloadDataTicket, [
      'single_ticket_price_amount',
      'single_ticket_price_currency',
    ]);

    return {
      ...ticket,
      ...payloadDataTicket,
    };
  });

  return {
    ...state,
    ...data,
    ...id,
    tickets,
  };
}

export function reducer(state = initialState, action: fromActions.MemberEventBookingActions) {
  switch (action.type) {
    case fromActions.UPDATE_BOOKING_RESET:
    case fromActions.CLEAR_BOOKING_LOCAL_SUCCESS:
      return initialState;

    case fromActions.CREATE_BOOKING:
      return {
        ...state,
        error: null,
      };

    case fromActions.GET_BOOKING_SUCCESS:
      return transformMemberEventBooking(state, action.payload);

    case fromActions.CREATE_BOOKING_SUCCESS: {
      const payload = { ...action.payload };
      delete payload.event_date;
      return transformMemberEventBooking(state, payload);
    }
    case fromActions.CREATE_BOOKING_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    case fromActions.UPDATE_BOOKING_SUCCESS:
      return {
        ...state,
        ...action.payload,
        is_complete: true,
        was_successful:
          (action.payload.payment_status === 'done' ||
            action.payload.payment_status === 'authorized' ||
            action.payload.payment_status === 'authorised') &&
          action.payload.status === 'booked',
      };

    case fromActions.UPDATE_BOOKING_FAILURE:
      return {
        ...state,
        is_complete: true,
        was_successful: false,
      };

    case fromActions.UPDATE_BOOKING_LOCAL_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
